import type { ToolResultData } from './types';
import { getToolConfig, getContentTypeRenderer } from '../tool-config';
import { PlainTextRenderer } from './renderers';
import type { OnOpenChatObject } from '../hitl-types';

type ToolResultRendererProps = {
  data: ToolResultData;
  maxHeight?: string;
  onOpenObject?: OnOpenChatObject;
};

export function ToolResultRenderer({
  data,
  maxHeight,
  onOpenObject,
}: ToolResultRendererProps) {
  const { content, contentType, toolName, input } = data;

  // First, try to get the tool-specific renderer from config
  const toolConfig = getToolConfig(toolName);
  if (toolConfig.renderOutput) {
    const result = toolConfig.renderOutput({
      content,
      maxHeight,
      input,
      onOpenObject,
    });
    if (result) return result;
  }

  // Fall back to content type renderer
  const contentTypeRenderer = getContentTypeRenderer(contentType);
  if (contentTypeRenderer) {
    return contentTypeRenderer({ content, maxHeight, input, onOpenObject });
  }

  // Final fallback to plain text
  return <PlainTextRenderer content={String(content)} maxHeight={maxHeight} />;
}
